import CommunityCard from './CommunityCard/CommunityCard'
import withAEM from '../../../hoc/withAEM'

const ReactCommunityCard = (props: any): JSX.Element => {
  const ReactCommunityCardWithAEM = withAEM(CommunityCard)
  return <ReactCommunityCardWithAEM {...props} compName={'React CommunityCard'} />
}
export default ReactCommunityCard
